module.exports = __webpack_public_path__ + "img/6134e3a.jpg";